module.exports = __webpack_public_path__ + "static/tools-resources-coffee-chat-photo@2x-7d948f65ce25c9d153f2ca6493e5e80b.jpg";